import { axiosInstance } from "../../../axios/axiosInstance";
import { LANDING_API_URL, getDefaultHeaders } from "../../../config";

const authHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  return {
    ...getDefaultHeaders(),
    Authorization: `Bearer ${authToken}`,
  };
};

export const getContacts = (dateRange = {}) =>
  axiosInstance.get(`${LANDING_API_URL}/contacts`, {
    headers: authHeaders(),
    params: dateRange,
  });

export const createContactRequest = (contactData) =>
  axiosInstance.post(`${LANDING_API_URL}/contacts`, contactData, {
    headers: authHeaders(),
  });

export const updateContactRequest = (id, contactData) =>
  axiosInstance.put(`${LANDING_API_URL}/contacts/${id}`, contactData, {
    headers: authHeaders(),
  });

export const removeContact = (contactId) =>
  axiosInstance.delete(`${LANDING_API_URL}/contacts/${contactId}`, {
    headers: authHeaders(),
  });

export const getSubjects = () =>
  axiosInstance.get(`${LANDING_API_URL}/get/subjects`, {
    headers: authHeaders(),
  });
